export const TEST_ID = 'serviceIntervalField';

export const RESET_BUTTON_TEST_ID = 'serviceIntervalFieldResetButton';

export const STEPPER_TEST_ID = 'serviceIntervalFieldStepper';

export const MAX_INTERVAL_VALUE = 100000;

export const MIN_INTERVAL_VALUE = 1;
